<router-outlet />
<p-toast position="top-right" />
<app-prd-confirm-dialog />
